import React from 'react';
import { Page } from 'components';
import { ShipmentsProvider } from './ShipmentsContext';
import Shipments from './Shipments';


let Index = () => {
    return (
        <ShipmentsProvider>
            <Page title="Shipments">
                <Shipments />
            </Page>
        </ShipmentsProvider>
    );
}

export default Index;